import React from 'react';
import cn from 'classnames';
import dayjs from 'dayjs';

import { formatPrice } from '../../../../utils/formatters';
import { createNextChargeDate, DATE_FORMAT } from '../../../../utils/dates';

import styles from './styles.module.scss';

const cardBrands = {
  visa: 'Visa',
  mastercard: 'MasterCard',
  amex: 'American Express',
  discover: 'Discover ',
  diners_club: 'Diners Club',
  'diners club': 'Diners Club',
};

const ChargeItem = ({ chargeInfo, type = 'upcoming', ...props }) => {
  const oneDay = 86400000;
  const defaultImagePath = 'images/products/default-product-image.png';
  const date =
    type === 'upcoming'
      ? createNextChargeDate(chargeInfo.scheduled_at)
      : dayjs(chargeInfo.processed_at);
  const currentDate = new Date();
  const orderPaymentData = chargeInfo?.paymentDetails;
  const diffDays = Math.ceil(Math.abs((date.toDate() - currentDate) / oneDay));
  const formattedDate = date.local().format(DATE_FORMAT);
  const isRefund = chargeInfo.status === 'refunded';
  const paymentDetails =
    chargeInfo?.include?.payment_methods?.[0]?.payment_details;
  const showPaymentDetails = paymentDetails || orderPaymentData;
  let cardBrand = '';
  let cardName = '';
  if (type === 'previous') {
    cardBrand = cardBrands[orderPaymentData?.company];
    if (orderPaymentData?.number) {
      cardName = `${cardBrand ?? orderPaymentData?.company} *${
        orderPaymentData?.number
      }`;
    }
  } else {
    cardBrand = cardBrands[paymentDetails?.brand?.toLowerCase()];
    cardName = `${cardBrand || paymentDetails?.brand || ''} *${
      paymentDetails?.last4
    }`;
  }
  const lineItemCount = chargeInfo?.line_items?.length;

  return (
    <div
      className={cn(styles.billingItem, {
        [styles.billingItemSingleItem]: lineItemCount === 1,
      })}
      {...props}
    >
      <div className={styles.billingItemPrice}>
        {isRefund && '-'}
        <span>$</span> {formatPrice(chargeInfo.total_price)}
      </div>
      <ul className={styles.billingItemLineItems}>
        {chargeInfo.line_items.map((item, index) => {
          return (
            <li key={index} className={styles.billingItemLineItem}>
              {item?.meta?.title ? (
                <img
                  src={item?.meta.billingIcon}
                  className={styles.billingItemImage}
                  alt={item.meta.title}
                ></img>
              ) : (
                <img
                  src={defaultImagePath}
                  className={styles.billingItemImage}
                  alt={item.title}
                ></img>
              )}
              <div className={styles.billingItemTitle}>{item.title}</div>
            </li>
          );
        })}
      </ul>
      <div className={styles.billingItemInfo}>
        {showPaymentDetails && (
          <>
            <span
              className={cn(
                styles.billingItemInfoItem,
                styles.billingItemInfoCard,
              )}
            >
              {cardName}
            </span>
            <span
              className={cn(
                styles.billingItemInfoSeparator,
                styles.billingItemInfoHideMobile,
              )}
            ></span>
          </>
        )}
        <span className={styles.billingItemInfoItem}>{formattedDate}</span>
        {chargeInfo.status === 'queued' && (
          <>
            <span className={styles.billingItemInfoSeparator}></span>
            <span className={styles.billingItemInfoItem}>
              in {diffDays} {diffDays > 1 ? `days` : `day`}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default ChargeItem;
